<template>
    <div class="page-container">
        <div style="flex: 1; min-width: 80%">
            <el-card class="noBorder" style="flex: 1">
                <el-table
                    :data="table_data"
                    border
                    style="width: 100%"
                    v-loading="tableLoading"
                    row-key="id"
                    :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                >
                    <el-table-column label="告警级别" prop="level" width="100" align="center"></el-table-column>
                    <el-table-column label="告警名称" prop="label" align="center"></el-table-column>
                    <el-table-column label="描述" prop="remark" align="center">
                        <template #default="{ row }">
                            <span v-if="row.remark">{{ row.remark }}</span>
                            <span v-else>无</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="文字颜色" prop="color" align="center">
                        <template #default="{ row }">
                            <span :style="{ color: row.color }">
                                <div style="height: 5px; width: 5px" :style="{ color: row.color }"></div>
                                {{ '■ ' + row.color }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="报警声音" prop="color" align="center">
                        <template #default="{ row }">
                            <el-icon
                                @click="playAudio(row.audio_url)"
                                style="font-size: 18px; cursor: pointer; color: var(--theme-color)"
                            >
                                <VideoPlay />
                            </el-icon>
                        </template>
                    </el-table-column>
                    <el-table-column width="120" label="文字闪烁" prop="flicker" align="center">
                        <template #default="{ row }">
                            <el-switch
                                v-model="row.flicker"
                                :active-value="1"
                                :inactive-value="0"
                                inline-prompt
                                active-text="是"
                                inactive-text="否"
                                @change="(val) => handleFlicker(val, row)"
                                style="--el-switch-on-color: #fc9d07"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column width="120" label="前台显示" prop="display" align="center">
                        <template #default="{ row }">
                            <el-switch
                                v-model="row.display"
                                :active-value="1"
                                :inactive-value="0"
                                inline-prompt
                                active-text="是"
                                inactive-text="否"
                                @change="(val) => handlePreset(val, row)"
                                style="--el-switch-on-color: #8c9eff"
                            />
                        </template>
                        <!-- " -->
                    </el-table-column>
                    <el-table-column width="120" label="声光报警" prop="sound_light" align="center">
                        <template #default="{ row }">
                            <el-switch
                                v-model="row.sound_light"
                                :active-value="1"
                                :inactive-value="0"
                                inline-prompt
                                active-text="是"
                                inactive-text="否"
                                @change="(val) => handleSoundAndLightAlarm(val, row)"
                                style="--el-switch-on-color: #ff3f34"
                            />
                        </template>
                        <!-- " -->
                    </el-table-column>
                    <el-table-column width="150" label="报警短信发送" prop="is_message" align="center">
                        <template #default="{ row }">
                            <el-switch
                                v-model="row.is_message"
                                :active-value="1"
                                :inactive-value="0"
                                inline-prompt
                                active-text="是"
                                inactive-text="否"
                                @change="(val) => handlePostMessage(val, row)"
                                style="--el-switch-on-color: #2ed573"
                            />
                        </template>
                        <!-- " -->
                    </el-table-column>
                    <el-table-column width="160" label="触发联动摄像头录制" prop="is_record" align="center">
                        <template #default="{ row }">
                            <el-switch
                                v-model="row.is_record"
                                :active-value="1"
                                :inactive-value="0"
                                inline-prompt
                                active-text="是"
                                inactive-text="否"
                                @change="(val) => handleCameraRecording(val, row)"
                                style="--el-switch-on-color: #22a6b3"
                            />
                        </template>
                        <!-- " -->
                    </el-table-column>

                    <el-table-column label="操作" fixed="right" width="290" align="center">
                        <template #default="{ row }">
                            <el-button
                                type="primary"
                                link
                                :icon="Edit"
                                size="small"
                                @click="onEditClick(row)"
                                v-permission="['alarm:manger:edit']"
                            >
                                修改
                            </el-button>
                            <el-button
                                type="primary"
                                link
                                :icon="ChatDotRound"
                                size="small"
                                v-permission="['alarm:manger:sendMsg']"
                                @click="onSendMsgManList(row)"
                            >
                                <!--     v-permission="['alarm:manger:sendMsg']" -->
                                短信人员列表
                            </el-button>
                            <el-button
                                type="primary"
                                link
                                :icon="Bell"
                                size="small"
                                v-permission="['alarm:manger:soundLight']"
                                @click="onSetSondLightALarm(row)"
                            >
                                <!--  v-permission="['alarm:manger:soundLight']" -->
                                声光报警设置
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>
        <forms-dialog
            v-if="formDialogVisible"
            v-model="formDialogVisible"
            :isForm="isForm"
            :alarmItem="selectAlarm"
            @updateForm="getTableData"
        ></forms-dialog>
        <imports-form
            v-if="uploadVisible"
            v-model="uploadVisible"
            @updateForm="getTableData"
            menuCode="event/source"
        ></imports-form>
        <sendMsgManList v-if="sendMsgDialogVisible" v-model="sendMsgDialogVisible" :alarmItem="selectAlarm"></sendMsgManList>
        <soundAndLightAlarmForm
            v-if="soundAndLightAlarmVisible"
            v-model="soundAndLightAlarmVisible"
            :alarmItem="selectAlarm"
        ></soundAndLightAlarmForm>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { Bell, ChatDotRound, Edit } from '@element-plus/icons' // Delete
import { batchAlarm, getAlarmLevelLists } from '@/api/eventConfig/alarmLevel/alarmLevel.js' // delAlarmLevel
import sendMsgManList from './components/sendMsgManList.vue'
import soundAndLightAlarmForm from './components/soundAndLightAlarmForm.vue'
import FormsDialog from './components/forms.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import ImportsForm from '@/components/ImportsForm.vue'

// // 重置
// const resetQueryForm = () => {
//     Object.keys(queryForms.value).forEach((key) => {
//         if (key !== 'page' && key !== 'page_size') queryForms.value[key] = ''
//     })
//     getTableData()
// }
// 数据源
const table_data = ref([])
const tableLoading = ref(false)
const total = ref(0)

const getOptionData = async () => {}

// 获取列表数据
const getTableData = async () => {
    tableLoading.value = true
    const result = await getAlarmLevelLists()
    table_data.value = result
    total.value = result.total
    tableLoading.value = false
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectAlarm = ref('') // 点中的模块id
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) selectAlarm.value = ''
})

// 编辑
const onEditClick = (row) => {
    isForm.value = true
    selectAlarm.value = { ...row }
    // console.log(selectAlarm.value)
    formDialogVisible.value = true
}
// // 添加
// const onAddClick = () => {
//     selectModelId.value = ''
//     isForm.value = true
//     formDialogVisible.value = true
// }

// 删除

// const onRemoveClick = (row) => {
//     ElMessageBox.confirm('确定要删除 ' + row.label + ' 吗？', {
//         type: 'warning',
//
//
//     })
//         .then(async () => {
//             if (row.pid == null) {
//                 await delAlarmLevel(row.id)
//             } else {
//             }
//             ElMessage.success('删除成功！')
//             // 重新渲染数据
//             getTableData()
//         })
//         .catch(() => {})
// }

const uploadVisible = ref(false)

// 导出
// const handleExport = async () => {
//     ElMessageBox.confirm('您确定导出全部事件源信息吗？', {
//         type: 'warning',
//
//
//     })
//         .then(async () => {
//             console.log({ ...queryForms.value, export: 1 })
//             const { data } = await getEventSourceLists({ ...queryForms.value, export: 1 })
//             console.log(11111, data)
//             window.open(data)
//             ElMessage.success('导出成功')
//         })
//         .catch(() => {})
// }

// 播放声音
const isPlay = ref(false)
let myAudio = null
const playAudio = (url) => {
    if (myAudio) {
        myAudio.pause()
        myAudio = null
    }
    myAudio = new Audio(url)
    isPlay.value = !isPlay.value
    if (isPlay.value) {
        myAudio.play()
    } else {
        myAudio.pause()
    }
    myAudio.addEventListener('ended', () => {
        isPlay.value = false
    })
}

// 修改闪烁状态
const handleFlicker = (val, row) => {
    if (!row.id) return
    const msg = val ? '开启' : '关闭'
    ElMessageBox.confirm(`是否确认要"${msg}""${row.label}"闪烁吗？`, '系统提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            try {
                if (val) {
                    await batchAlarm({ method: 'batch_flicker', data: [row.id] })
                } else {
                    await batchAlarm({ method: 'batch_freeze', data: [row.id] })
                }
                ElMessage({
                    type: 'success',
                    message: msg + '闪烁' + '成功'
                })
            } catch (error) {}
        })
        .catch(() => {
            row.flicker = val ? 0 : 1
        })
}
// 前台是否显示
const handlePreset = (val, row) => {
    if (!row.id) return
    const msg = val ? '开启' : '关闭'
    ElMessageBox.confirm(`是否确认要"${msg}""${row.label}"前台显示吗？`, '系统提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            try {
                if (val) {
                    batchAlarm({ method: 'batch_display', data: [row.id] })
                } else {
                    batchAlarm({ method: 'batch_hidden', data: [row.id] })
                }
                ElMessage({
                    type: 'success',
                    message: msg + '前台显示' + '成功'
                })
            } catch (error) {}
        })
        .catch(() => {
            row.display = val ? 0 : 1
        })
}
// 是否声光报警
const handleSoundAndLightAlarm = (val, row) => {
    if (!row.id) return
    const msg = val ? '开启' : '关闭'
    ElMessageBox.confirm(`是否确认要"${msg}""${row.label}"声光报警吗？`, '系统提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            try {
                if (val) {
                    batchAlarm({ method: 'sound_light_on', data: [row.id] })
                } else {
                    batchAlarm({ method: 'sound_light_off', data: [row.id] })
                }
                ElMessage({
                    type: 'success',
                    message: msg + '声光报警' + '成功'
                })
            } catch (error) {}
        })
        .catch(() => {
            row.sound_light = val ? 0 : 1
        })
}

// 是否发送告警短信
const handlePostMessage = (val, row) => {
    if (!row.id) return
    const msg = val ? '开启' : '关闭'
    ElMessageBox.confirm(`是否确认要"${msg}""${row.label}"发送告警短信吗？`, '系统提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            try {
                if (val) {
                    batchAlarm({ method: 'is_message_on', data: [row.id] })
                } else {
                    batchAlarm({ method: 'is_message_off', data: [row.id] })
                }
                ElMessage({
                    type: 'success',
                    message: msg + '发送告警短信' + '成功'
                })
            } catch (error) {}
        })
        .catch(() => {
            row.is_message = val ? 0 : 1
        })
}
// 是否告警后录制摄像头
const handleCameraRecording = (val, row) => {
    if (!row.id) return
    const msg = val ? '开启' : '关闭'
    ElMessageBox.confirm(`是否确认要"${msg}""${row.label}"联动摄像头录制吗？`, '系统提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            try {
                if (val) {
                    batchAlarm({ method: 'is_record_on', data: [row.id] })
                } else {
                    batchAlarm({ method: 'is_record_off', data: [row.id] })
                }
                ElMessage({
                    type: 'success',
                    message: msg + '联动摄像头录制' + '成功'
                })
            } catch (error) {}
        })
        .catch(() => {
            row.is_record = val ? 0 : 1
        })
}

// 发送短信人员列表
const sendMsgDialogVisible = ref(false)
const onSendMsgManList = (row) => {
    sendMsgDialogVisible.value = true
    selectAlarm.value = { ...row }
}

// 声光报警
const soundAndLightAlarmVisible = ref(false)
const onSetSondLightALarm = (row) => {
    soundAndLightAlarmVisible.value = true
    selectAlarm.value = { ...row }
}

// 切换到前台时候执行
onMounted(() => {
    getOptionData()
    getTableData()
})
</script>

<style scoped></style>
